import React, { useState } from "react";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import { Typography, Paper, Box, Grid, makeStyles } from "@material-ui/core";
import SearchCaseForm from "../Components/SearchCase";
import Adjournments from "../Components/Adjournments";
import { getCaseReferenceNumber } from "../utils";

const useStyles = makeStyles((theme) => ({
  container: {
    textAlign: "left",
  },
  detailsPaper: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(3),
    borderRadius: 8,
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  detailBox: {
    backgroundColor: "#F9FAFB",
    padding: theme.spacing(2),
    borderRadius: 6,
    border: "1px solid #EAECF0",
    marginBottom: theme.spacing(3),
  },
  detailLabel: {
    fontSize: "0.75rem",
    color: TEXT.muted,
    fontWeight: 500,
    textTransform: "uppercase",
    marginBottom: theme.spacing(0.5),
  },
  detailValue: {
    fontSize: "0.95rem",
    color: TEXT.strong,
    fontWeight: 600,
    // Long values (e.g. a CMP / MSEFC number) wrap inside their column
    // instead of running into the next one.
    overflowWrap: "anywhere",
  },
}));

/**
 * Admin "Adjournments" tab: search a case, then work its adjournments (pending
 * requests + the direct-adjournment form) exactly as on the case-detail screen.
 * Access to this tab is gated by the `adjournment` feature in the sidebar.
 */
const AdjournmentsTab = ({ profile }) => {
  const classes = useStyles();
  const [searchedCase, setSearchedCase] = useState(null);

  const handleSearchSuccess = (caseData) => setSearchedCase(caseData);
  const handleSearchError = () => setSearchedCase(null);

  const refNo = getCaseReferenceNumber(searchedCase);

  return (
    <Box className={classes.container}>
      <Box mb={3}>
        <SearchCaseForm
          handleSearchSuccess={handleSearchSuccess}
          handleSearchError={handleSearchError}
        />
      </Box>

      {searchedCase && (
        <Paper className={classes.detailsPaper} elevation={1}>
          <Typography variant="h6" className={classes.sectionTitle} color="primary" gutterBottom>
            Case Details: {searchedCase.tiac_custom_dispute_id}
          </Typography>

          <Box className={classes.detailBox}>
            <Grid container spacing={2}>
              {refNo && (
                <Grid item xs={12} sm={3}>
                  <Typography className={classes.detailLabel}>{refNo.label}</Typography>
                  <Typography className={classes.detailValue}>{refNo.value}</Typography>
                </Grid>
              )}
              <Grid item xs={12} sm={refNo ? 3 : 4}>
                <Typography className={classes.detailLabel}>Claimant</Typography>
                <Typography className={classes.detailValue}>
                  {searchedCase.claimant?.name || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={refNo ? 3 : 4}>
                <Typography className={classes.detailLabel}>Respondent</Typography>
                <Typography className={classes.detailValue}>
                  {searchedCase.respondent?.name || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={refNo ? 3 : 4}>
                <Typography className={classes.detailLabel}>Current Stage</Typography>
                <Typography className={classes.detailValue}>
                  {searchedCase.arbitration_stage || searchedCase.current_stage || "N/A"}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Adjournments
            disputeId={searchedCase.id}
            profile={profile}
            allProfiles={[]}
          />
        </Paper>
      )}
    </Box>
  );
};

export default AdjournmentsTab;
